import { useEffect } from 'react'

/**
 * 统一设置页面标题为 systemTitle
 * 所有 user 端页面都使用相同的标题，不根据页面变化
 */
export function usePageTitle() {
  useEffect(() => {
    const title = localStorage.getItem('systemTitle') || '健康积分'
    document.title = title
  }, [])
}
